import type { Placement } from 'react-laag/dist/ToggleLayer/types';

/**
 * The default {@link Placement} configuration for a react-laag/ToggleLayer.
 */
export const DEFAULT_PLACEMENT_CONFIG: Placement = {
  anchor: 'BOTTOM_LEFT',
  autoAdjust: true,
  snapToAnchor: true,
  triggerOffset: 12,
  scrollOffset: 16,
  possibleAnchors: [
    'TOP_LEFT',
    'TOP_CENTER',
    'TOP_RIGHT',
    'BOTTOM_LEFT',
    'BOTTOM_CENTER',
    'BOTTOM_RIGHT',
    'LEFT_TOP',
    'LEFT_CENTER',
    'LEFT_BOTTOM',
    'RIGHT_TOP',
    'RIGHT_CENTER',
    'RIGHT_BOTTOM'
  ]
};
